import type { Translations } from './en';

export const ru: Translations = {
  nav: {
    services: 'Услуги',
    portfolio: 'Портфолио',
    starModel: 'Звездная Модель',
    partners: 'Партнеры',
    about: 'О нас',
    contact: 'Контакты',
    getStarted: 'Начать',
    closeMenu: 'Закрыть меню',
    openMenu: 'Открыть меню',
  },
  hero: {
    title: 'Создаем деловое совершенство завтрашнего дня',
    subtitle: 'Impresstars координирует высокоэффективные бизнес-операции через нашу инновационную систему Star Model. От регистрации компании до стратегии роста — мы ваш партнер в операционном совершенстве.',
    exploreServices: 'Изучить услуги',
    learnMore: 'Подробнее',
  },
  services: {
    eyebrow: 'Что мы делаем',
    title: 'Наши услуги',
    incorporation: {
      title: 'Услуги по регистрации',
      description: 'Начните бизнес правильно с нашим упрощенным процессом регистрации. Создание LLC, Corp или некоммерческой организации — просто.',
    },
    aiSolutions: {
      title: 'ИИ-решения',
      description: 'Услуги по интеграции ИИ на заказ, включая модели машинного обучения, обработку естественного языка и автоматизированные системы принятия решений.',
    },
    b2bSolutions: {
      title: 'B2B-решения',
      description: 'Комплексные B2B-услуги, включая развитие партнерств, оптимизацию цепочек поставок и аутсорсинг бизнес-процессов.',
    },
    marketingStrategy: {
      title: 'Маркетинговая стратегия',
      description: 'Основанные на данных маркетинговые стратегии, адаптированные под ваши бизнес-цели, включая анализ рынка и планирование роста.',
    },
    businessSoftware: {
      title: 'Бизнес-софт',
      description: 'Определите и внедрите правильные программные решения для оптимизации операций и повышения производительности.',
    },
    brandDesign: {
      title: 'Дизайн бренда',
      description: 'Профессиональный дизайн логотипов, разработка фирменного стиля и маркетинговых материалов, создающих неизгладимое впечатление.',
    },
    businessConsulting: {
      title: 'Бизнес-консалтинг',
      description: 'Стратегическое руководство для оптимизации ваших операций и ускорения роста через проверенные методологии.',
    },
    ctaTitle: 'Готовы трансформировать свой бизнес?',
    ctaText: 'Давайте обсудим, как наши услуги помогут вам достичь ваших целей.',
    ctaButton: 'Начать',
  },
  starModel: {
    eyebrow: 'Связаны по замыслу',
    title: 'Звездные модели',
    description: 'Откройте для себя нашу экосистему специализированных бизнес-единиц и операционную методологию, лежащую в их основе.',
    learnHow: 'Как работает Звездная модель',
    captionLeft: 'Связанные операции',
    captionRight: 'Общий импульс',
    cleaningEdge: {
      title: 'Cleaning EDGE',
      status: 'Активна',
      description: 'Профессиональные клининговые услуги, переосмысленные через технологии и исключительные стандарты обслуживания.',
      details: 'Cleaning EDGE — это профессиональная клининговая компания, специализирующаяся на надежных жилых и коммерческих услугах, включая уборку после ремонта и автодетейлинг, с цифровыми рабочими процессами, облегчающими бронирование, общение и контроль обслуживания.',
    },
    ozean: {
      title: 'Ozean',
      status: 'В разработке',
      description: 'Платформа стокового аудио, предлагающая звуковые ресурсы для создателей, редакторов, брендов и рассказчиков.',
      details: 'Ozean специализируется на кураторском стоковом аудио, помогая творческим командам находить треки и звуковые элементы для производства контента.',
    },
    visitWebsite: 'Посетить сайт',
  },
  testimonials: {
    eyebrow: 'Истории клиентов',
    title: 'Отзывы клиентов',
    description: 'Не верьте нам на слово — послушайте, что наши клиенты говорят о работе с Impresstars.',
    j94Designs: 'Impresstars поддержала нас HR-консалтингом и помогла создать ключевые части нашего сайта на Wix.',
    craftPapi: 'Impresstars разработала практичный маркетинговый план для нашей команды, сделав наши кампании и приоритеты гораздо яснее.',
    pawStuffs: 'Impresstars продолжает поддерживать наш сайт на Shopify и предоставляет постоянную поддержку по мере роста нашего магазина.',
  },
  portfolio: {
    eyebrow: 'Избранные работы',
    title: 'Наше портфолио',
    description: 'Изучите наши недавние проекты и истории успеха в различных отраслях и услугах.',
    filterAll: 'Все',
    filterWebsites: 'Веб-сайты',
    filterApps: 'Приложения и инструменты',
    filterGames: 'Игры',
    filterConsulting: 'Консалтинг',
    production: 'Продакшн',
    showcase: 'Витрина',
    viewCaseStudy: 'Посмотреть кейс',
    visitSite: 'Посетить сайт',
    openProject: 'Открыть проект',
    viewServices: 'Наши услуги',
    startProject: 'Начать проект',
    filterAllProjects: 'Все проекты',
    filterRealWorld: 'Продакшн',
    filterShowcase: 'Витрина',
    sortFeatured: 'Рекомендуемые',
    sortAZ: 'Название: A-Я',
    sortZA: 'Название: Я-A',
    sortLabel: 'Сортировать по:',
    reset: 'Сбросить',
    showing: 'Показано',
    of: 'из',
    projects: 'проектов',
    noProjects: 'Для этого фильтра проекты пока не найдены.',
    visitProjectWebsite: 'Посетить сайт проекта',
    catBrandWebsite: 'Сайт бренда',
    catWebDevelopment: 'Веб-разработка',
    catEcommerceWebsite: 'Интернет-магазин',
    catBusinessWebsite: 'Бизнес-сайт',
    catWebsite: 'Веб-сайт',
    catJewelleryBrand: 'Ювелирный бренд',
    catWebApp: 'Веб-приложение',
    catInteractiveApp: 'Интерактивное приложение',
    catUtilityTool: 'Утилита',
    cat3DWebSandbox: '3D веб-песочница',
    catWebGame: 'Веб-игра',
    catGameExperience: 'Игровой опыт',
    catConsultingMarketingPlan: 'Консалтинг и маркетинговый план',
    desc: {
      snouts: 'Веб-работы, поддерживающие онлайн-присутствие бренда Snouts.',
      innovaPro: 'Создание сайта для Innova Pro с фокусом на четкую презентацию услуг и высокую производительность.',
      pawstuffs: 'Веб-присутствие интернет-магазина и поддержка для Pawstuffs.',
      cleaningEdge: 'Работа над сайтом и цифровым присутствием для Cleaning EDGE.',
      cheesePanic: 'Кот гонится за мышью, мышь хочет сыр. Небольшая хаотичная веб-игра.',
      cleaningEdgeApp: 'Платформа самообслуживания, ориентированная на операции для клиентов и работников Cleaning EDGE. Протестируйте демо-версию с паролем cleaningEDGE и выберите Legacy Mode.',
      angoloDiamonds: 'Работа по веб-разработке для Angolo Diamonds.',
      craftPapiGrowth: 'Разработка плана консалтинга и маркетинга для Craft Papi для укрепления позиционирования и реализации роста.',
      roboticVoiceClicker: 'Активируемый голосом кликер с игривым взаимодействием кнопки-ящерицы.',
      cheatCounter: 'Хорхе снова посмотрел верхнюю карту своей колоды. Кто-то должен был считать.',
      klondikeSolitaire: 'Презентация и взаимодействие веб-игры, вдохновленной классическим пасьянсом.',
      universeAdventure: 'Концепция космического приключения с галактическими путешествиями и исследованием на кораблях.',
      interiorDesign3d: 'Браузерная песочница Three.js для импорта 3D-моделей и создания интерьеров.',
      pavillionJewellery: 'Бренд-ориентированная презентация сайта для Pavillion Jewellery.',
      hauntedGalleria: 'Иммерсивный сайт-витрина в тёмной тематике для опыта призрачной галереи с атмосферными визуалами и жуткими анимациями.',
    },
  },
  partners: {
    eyebrow: 'Надежные технологии',
    title: 'Инструменты, которые мы используем и рекомендуем',
    description: 'Это платформы, с которыми мы активно работаем и рекомендуем нашим клиентам. Если вы зарегистрируетесь по нашим ссылкам, мы можем получить реферальное вознаграждение — без дополнительных затрат для вас.',
    teaserEyebrow: 'Надежные технологии',
    teaserTitle: 'Рекомендуемые инструменты',
    seeAllPartners: 'Все партнеры',
    getStarted: 'Начать',
    ctaTitle: 'Нужна помощь с выбором правильного стека?',
    ctaText: 'Мы оцениваем, внедряем и интегрируем инструменты в ваш рабочий процесс. Доверьте технику нам, чтобы вы могли сосредоточиться на бизнесе.',
    ctaButton: 'Связаться с нами',
    disclaimer: 'Некоторые ссылки на этой странице — реферальные. Impresstars может получать комиссию, если вы зарегистрируетесь — без дополнительных затрат для вас.',
    catProductivity: 'Продуктивность',
    catAIVoice: 'ИИ и голос',
    catBusinessPhone: 'Бизнес-телефон',
    catAIWebBuilder: 'ИИ веб-конструктор',
  },
  about: {
    eyebrow: 'Наша цель',
    title: 'О Impresstars',
    p1: 'В Impresstars мы верим в трансформацию бизнес-операций через инновации и совершенство. Наша миссия — помочь компаниям раскрыть свой полный потенциал, внедряя передовые решения и проверенные методологии.',
    p2: 'Основанные на принципах операционного совершенства и устойчивого роста, мы разработали нашу уникальную систему Star Model, которая помогла множеству бизнесов достичь выдающегося успеха.',
  },
  clients: {
    title: 'Наши клиенты',
    description: 'Мы гордимся работой с этими организациями и помощью им в росте через наши услуги и преданную поддержку.',
  },
  techPlatforms: {
    title: 'Технологии и платформы, которые мы поддерживаем',
    description: 'Мы можем помочь с внедрением, оптимизацией или поддержкой этих инструментов и платформ.',
    catEcommerce: 'Электронная коммерция и сайты',
    catAI: 'ИИ и автоматизация',
    catMarketing: 'Маркетинг и рост',
    catCloud: 'Облако и инфраструктура',
    catCreative: 'Креативное и брендовое производство',
    focusEcommerce: 'Ключевая компетенция: запуск и поддержка ориентированных на конверсию магазинов и бизнес-сайтов.',
    focusAI: 'Ключевая компетенция: практическое внедрение ИИ и автоматизация рабочих процессов для растущих команд.',
    focusMarketing: 'Ключевая компетенция: отслеживание показателей, выполнение кампаний и базовое SEO.',
    focusCloud: 'Ключевая компетенция: надежное развертывание и поддержка сред для современных веб-операций.',
    focusCreative: 'Ключевая компетенция: брендовые ресурсы, поддерживающие маркетинг и продуктовый сторителлинг.',
  },
  contact: {
    title: 'Свяжитесь с нами',
    description: 'Готовы трансформировать свой бизнес? Отправьте нам сообщение, и мы ответим в течение 24 часов.',
    name: 'Имя',
    namePlaceholder: 'Ваше имя',
    email: 'Электронная почта',
    emailPlaceholder: 'ваш@email.com',
    reason: 'Причина обращения',
    reasonPlaceholder: 'Выберите причину',
    message: 'Сообщение',
    messagePlaceholder: 'Чем мы можем вам помочь?',
    sending: 'Отправка...',
    send: 'Отправить сообщение',
    successTitle: 'Сообщение отправлено!',
    successText: 'Спасибо за обращение. Мы скоро свяжемся с вами.',
    sendAnother: 'Отправить еще сообщение',
    recaptchaError: 'Пожалуйста, пройдите проверку reCAPTCHA.',
    submitError: 'Отправка не удалась. Попробуйте снова или напишите нам на email.',
    reasons: {
      incorporationServices: 'Услуги по регистрации',
      aiSolutions: 'ИИ-решения',
      b2bSolutions: 'B2B-решения',
      marketingStrategy: 'Маркетинговая стратегия',
      businessSoftware: 'Бизнес-софт',
      brandDesign: 'Дизайн бренда',
      businessConsulting: 'Бизнес-консалтинг',
      websiteDevelopment: 'Веб-разработка',
      websiteSupport: 'Поддержка / обслуживание сайта',
      ecommerceSupport: 'Поддержка интернет-магазина',
      generalQuestion: 'Общий вопрос',
      partnership: 'Возможность партнерства',
    },
  },
  footer: {
    tagline: 'Трансформация бизнес-операций через инновации и совершенство.',
    quickLinks: 'Быстрые ссылки',
    starModels: 'Звездные модели',
    legal: 'Правовая информация',
    termsConditions: 'Условия и положения',
    privacyPolicy: 'Политика конфиденциальности',
    contactTitle: 'Контакты',
    city: 'Лондон, ОН',
    country: 'Канада',
    rightsReserved: 'Impresstars. Все права защищены.',
    notALawFirm: 'Impresstars не является юридической фирмой и не предоставляет юридических консультаций.',
  },
  notFound: {
    title: 'Страница не найдена',
    metaDescription: 'Страница, которую вы ищете, не существует или была перемещена.',
    heading: 'Страница не найдена',
    text: 'Страница, которую вы ищете, не существует или, возможно, была перемещена. Давайте вернем вас на правильный путь.',
    backHome: 'На главную',
    contactUs: 'Связаться с нами',
    portfolio: 'Портфолио',
    services: 'Услуги',
  },
  caseStudy: {
    notFound: 'Кейс не найден',
    returnHome: 'На главную',
    backToPortfolio: 'Вернуться в портфолио',
    client: 'Клиент:',
    challenge: 'Задача',
    solution: 'Наше решение',
    keyResults: 'Ключевые результаты',
    technologiesUsed: 'Использованные технологии',
    visitProject: 'Посетить проект',
    items: {
      cleaningEdgePlatform: {
        title: 'Платформа Cleaning EDGE',
        category: 'Веб-разработка',
        client: 'Cleaning EDGE',
        description: 'Комплексная цифровая платформа для управления клининговыми услугами, включая планирование, управление командой и отзывы клиентов.',
        challenge: 'Клиенту требовалось масштабируемое решение для управления растущими операциями клининговых услуг, обработки бронирований клиентов и оптимизации планирования команд в нескольких локациях.',
        solution: 'Мы разработали кастомную веб-платформу, интегрирующую управление бронированиями, планирование команд и отслеживание в реальном времени. Решение включает клиентский портал, админ-панель и мобильный интерфейс для клининговых команд.',
        results: [
          'Снижение конфликтов в расписании на 95%',
          'Повышение удовлетворенности клиентов до 98%',
          'Повышение эффективности команды на 40%',
          'Расширение на 3 новые локации',
        ],
      },
      aiAnalyticsDashboard: {
        title: 'ИИ-панель аналитики',
        category: 'ИИ-решения',
        client: 'TechVision Inc.',
        description: 'Кастомная аналитическая панель с машинным обучением для прогнозирования бизнес-трендов и оптимизации операций.',
        challenge: 'Клиенту было сложно разобраться в огромном массиве данных, и ему нужны были предиктивные инсайты для принятия лучших бизнес-решений.',
        solution: 'Мы внедрили систему машинного обучения, которая анализирует исторические данные, прогнозирует тренды и предоставляет действенные инсайты через интуитивный интерфейс панели.',
        results: [
          'Повышение точности прогнозов на 85%',
          'Сокращение времени принятия решений на 60%',
          'Генерация экономии в 2 млн $',
          'Улучшение управления запасами на 45%',
        ],
      },
      globalMarketingCampaign: {
        title: 'Глобальная маркетинговая кампания',
        category: 'Маркетинговая стратегия',
        client: 'Global Solutions Ltd',
        description: 'Комплексная стратегия цифрового маркетинга, увеличившая присутствие клиента на трех континентах.',
        challenge: 'Клиенту нужно было расширить глобальное присутствие, сохраняя единый брендовый месседж и вовлеченность в разных культурных контекстах.',
        solution: 'Мы разработали многоканальную маркетинговую стратегию с локализованным контентом, таргетированной рекламой и культурной адаптацией маркетинговых материалов.',
        results: [
          'Охвачено более 2 млн новых потенциальных клиентов',
          'Рост глобальных продаж на 150%',
          'Улучшение узнаваемости бренда на 80%',
          'Генерировано 300% ROI маркетинговых расходов',
        ],
      },
      hauntedGalleria: {
        title: 'Haunted Galleria',
        category: 'Веб-дизайн и разработка',
        client: 'Haunted Galleria',
        description: 'Иммерсивный сайт-витрина в тёмной тематике для опыта призрачной галереи — атмосферные визуалы, жуткие анимации и смелая типографика.',
        challenge: 'Клиенту нужно было веб-присутствие, соответствующее драматической и таинственной природе концепции призрачной галереи.',
        solution: 'Мы создали полностью уникальный сайт с тёмной атмосферной эстетикой, эффектами параллакса и вдохновлённой хоррором типографикой для нагнетания напряжения.',
        results: [
          'Выразительная идентичность бренда на нишевом рынке',
          'Иммерсивный UX, удерживающий посетителей дольше',
          'Полностью адаптивен на всех устройствах',
          'Оптимизирован для быстрой загрузки несмотря на богатые визуальные эффекты',
        ],
      },
    },
  },
  servicePages: {
    incorporation: {
      title: 'Услуги по регистрации',
      metaDescription: 'Начните свой бизнес-путь уверенно. Наши услуги по регистрации обеспечивают прочную основу для будущего успеха вашей компании.',
      intro: 'Начните свой бизнес-путь уверенно. Наши услуги по регистрации обеспечивают прочную основу для будущего успеха вашей компании.',
      disclaimer: 'Уведомление: Impresstars не является юридической фирмой и не предоставляет юридических консультаций. Мы рекомендуем проконсультироваться с квалифицированным адвокатом для юридического руководства.',
      structureOptions: 'Варианты структуры бизнеса',
      structureItems: [
        'ООО с ограниченной ответственностью (LLC)',
        'Корпорация (C-Corp, S-Corp)',
        'Некоммерческая организация',
        'Формирование партнерств',
      ],
      included: 'Что включено',
      includedItems: [
        'Проверка названия бизнеса',
        'Учредительные документы',
        'Регистрация EIN',
        'Операционное соглашение',
      ],
      ctaTitle: 'Готовы зарегистрировать компанию?',
      ctaText: 'Давайте обсудим лучшую структуру для вашего бизнеса и начнем с правильного пути.',
      ctaButton: 'Запланировать консультацию',
    },
    aiSolutions: {
      title: 'ИИ-решения',
      metaDescription: 'Трансформируйте свой бизнес с передовыми решениями искусственного интеллекта, адаптированными под ваши конкретные нужды.',
      intro: 'Трансформируйте свой бизнес с передовыми решениями искусственного интеллекта, адаптированными под ваши конкретные нужды.',
      servicesTitle: 'ИИ-услуги',
      servicesItems: [
        'Модели машинного обучения',
        'Обработка естественного языка',
        'Решения компьютерного зрения',
        'Предиктивная аналитика',
      ],
      implAreas: 'Области внедрения',
      implItems: [
        'Автоматизация клиентского сервиса',
        'Анализ данных и инсайты',
        'Оптимизация процессов',
        'Системы поддержки решений',
      ],
      ctaTitle: 'Готовы внедрить ИИ?',
      ctaText: 'Давайте изучим, как ИИ может революционизировать ваши бизнес-операции и стимулировать рост.',
      ctaButton: 'Начать',
    },
    b2bSolutions: {
      title: 'B2B-решения',
      metaDescription: 'Оптимизируйте ваши B2B-операции с нашими комплексными решениями для современных предприятий.',
      intro: 'Оптимизируйте ваши B2B-операции с нашими комплексными решениями для современных предприятий.',
      coreServices: 'Основные услуги',
      coreServicesItems: [
        'Оптимизация цепочек поставок',
        'Развитие партнерств',
        'Аутсорсинг процессов',
        'Стратегическое планирование',
      ],
      benefits: 'Преимущества',
      benefitsItems: [
        'Повышенная эффективность',
        'Снижение затрат',
        'Расширение рынка',
        'Рост доходов',
      ],
      ctaTitle: 'Трансформируйте ваши B2B-операции',
      ctaText: 'Давайте оптимизируем ваши деловые отношения и процессы для максимальной эффективности.',
      ctaButton: 'Связаться с нами',
    },
    marketingStrategy: {
      title: 'Маркетинговая стратегия',
      metaDescription: 'Разработайте мощную маркетинговую стратегию, которая стимулирует рост и связывается с вашей целевой аудиторией.',
      intro: 'Разработайте мощную маркетинговую стратегию, которая стимулирует рост и связывается с вашей целевой аудиторией.',
      strategyComponents: 'Компоненты стратегии',
      strategyItems: [
        'Анализ рынка',
        'Исследование конкурентов',
        'Профилирование целевой аудитории',
        'Канальная стратегия',
      ],
      deliverables: 'Результаты',
      deliverablesItems: [
        'Маркетинговый план',
        'Контент-стратегия',
        'Дорожная карта кампаний',
        'Прогнозы ROI',
      ],
      ctaTitle: 'Готовы к росту?',
      ctaText: 'Давайте создадим маркетинговую стратегию, которая выведет ваш бизнес на новый уровень.',
      ctaButton: 'Начать планирование',
    },
    brandDesign: {
      title: 'Дизайн бренда',
      metaDescription: 'Создайте запоминающуюся брендовую идентичность, которая резонирует с вашей аудиторией и выделяется на рынке.',
      intro: 'Создайте запоминающуюся брендовую идентичность, которая резонирует с вашей аудиторией и выделяется на рынке.',
      designServices: 'Услуги дизайна',
      designItems: [
        'Дизайн логотипа',
        'Руководство по бренду',
        'Визуальная идентичность',
        'Маркетинговые материалы',
      ],
      deliverables: 'Результаты',
      deliverablesItems: [
        'Гайдлайн бренда',
        'Пакет логотипов',
        'Цветовая палитра',
        'Типографическая система',
      ],
      ctaTitle: 'Готовы к новому облику?',
      ctaText: 'Давайте создадим брендовую идентичность, которая воплотит ваше видение и свяжется с вашей аудиторией.',
      ctaButton: 'Начать процесс дизайна',
    },
    businessConsulting: {
      title: 'Бизнес-консалтинг',
      metaDescription: 'Получите экспертное руководство для оптимизации ваших операций и ускорения роста бизнеса через проверенные методологии.',
      intro: 'Получите экспертное руководство для оптимизации ваших операций и ускорения роста бизнеса через проверенные методологии.',
      consultingAreas: 'Области консалтинга',
      consultingItems: [
        'Стратегическое планирование',
        'Оптимизация операций',
        'Финансовый анализ',
        'Стратегия роста',
      ],
      benefits: 'Преимущества',
      benefitsItems: [
        'Улучшенная эффективность',
        'Снижение затрат',
        'Рост доходов',
        'Лучшая принятие решений',
      ],
      ctaTitle: 'Готовы оптимизировать?',
      ctaText: 'Давайте проанализируем ваш бизнес и создадим дорожную карту для устойчивого роста.',
      ctaButton: 'Забронировать консультацию',
    },
    businessSoftware: {
      title: 'Решения для бизнес-софта',
      metaDescription: 'Трансформируйте ваши бизнес-операции с тщательно отобранными и внедренными программными решениями, которые оптимизируют процессы и повышают эффективность.',
      intro: 'Трансформируйте ваши бизнес-операции с тщательно отобранными и внедренными программными решениями, которые оптимизируют процессы и повышают эффективность.',
      ourApproach: 'Наш подход',
      approachItems: [
        'Анализ бизнес-процессов',
        'Сбор требований к ПО',
        'Оценка и выбор решений',
        'Внедрение и интеграция',
      ],
      solutionAreas: 'Области решений',
      solutionItems: [
        'ERP-системы',
        'CRM-платформы',
        'Инструменты управления проектами',
        'Кастомная разработка ПО',
      ],
      ctaTitle: 'Готовы оптимизировать ваши операции?',
      ctaText: 'Давайте определим идеальные программные решения для трансформации ваших бизнес-процессов.',
      ctaButton: 'Запланировать консультацию',
    },
  },
  seo: {
    homeTitle: 'Создаем деловое совершенство завтрашнего дня',
    homeDescription: 'Impresstars координирует высокоэффективные бизнес-операции через нашу инновационную систему Star Model. От регистрации компании до стратегии роста — мы ваш партнер в операционном совершенстве.',
    portfolioTitle: 'Портфолио',
    portfolioDescription: 'Изучите нашу полную коллекцию успешных проектов и кейсов в различных отраслях.',
    partnersTitle: 'Рекомендуемые инструменты и партнеры',
    partnersDescription: 'Инструменты и платформы, которые Impresstars использует и рекомендует клиентам. Начните с первоклассных технологий через наши реферальные ссылки.',
  },
  languageSwitcher: {
    label: 'Язык',
  },
};
